import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type FolderIconProps = Partial<SVGIconProps>;
const FolderIcon: FC<FolderIconProps> = () => {
  return (
    <SVGIcon height="64" viewBox="0 0 83 64" width="83">
      <g clipPath="url(#clip0_519_15912)">
        <path
          d="M4.99998 63.4028H77.123C79.8845 63.4028 82.123 61.1642 82.123 58.4028V10.0187C82.123 7.25724 79.8845 5.01866 77.1231 5.01866H41.6116C40.0132 5.01866 38.5397 4.15442 37.7596 2.75933C36.9794 1.36424 35.5059 0.5 33.9075 0.5H4.99998C2.23856 0.5 -2.28882e-05 2.73857 -2.28882e-05 5.5V58.4028C-2.28882e-05 61.1642 2.23856 63.4028 4.99998 63.4028Z"
          fill="#E6B800"
        />
        <rect
          fill="black"
          fillOpacity="0.05"
          height="53.0014"
          rx="10"
          width="73.3866"
          x="3.49414"
          y="7.29492"
        />
        <rect
          fill="white"
          height="53.0014"
          rx="5"
          width="73.3866"
          x="4.27148"
          y="8.26562"
        />
        <path
          d="M72.1231 62.8209H10C4.47715 62.8209 0 58.3438 0 52.8209V26.7009C0 21.1781 4.47714 16.7009 9.99999 16.7009H40.1232C42.0229 16.7009 43.7437 15.5802 44.5117 13.8427C45.2797 12.1052 47.0005 10.9844 48.9002 10.9844H72.1231C77.6459 10.9844 82.1231 15.4615 82.1231 20.9844V52.8209C82.1231 58.3438 77.6459 62.8209 72.1231 62.8209Z"
          fill="black"
          fillOpacity="0.06"
        />
        <path
          d="M77.1231 63.403H5C2.23858 63.403 0 61.1644 0 58.403V22.283C0 19.5215 2.23857 17.283 4.99999 17.283H40.1232C42.0229 17.283 43.7437 16.1622 44.5117 14.4247C45.2797 12.6872 47.0005 11.5664 48.9002 11.5664H77.1231C79.8845 11.5664 82.1231 13.805 82.1231 16.5664V58.403C82.1231 61.1644 79.8845 63.403 77.1231 63.403Z"
          fill="#FFCC00"
        />
        <path
          clipRule="evenodd"
          d="M33.0703 63.5006H77.0267C79.7881 63.5006 82.0267 61.262 82.0267 58.5006V35.9102C68.2098 50.5296 49.2851 59.0149 33.0703 63.5006Z"
          fill="#EBBE0B"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_519_15912">
          <rect
            fill="white"
            height="63.0003"
            transform="translate(0 0.5)"
            width="82.1233"
          />
        </clipPath>
      </defs>
    </SVGIcon>
  );
};

export default FolderIcon;
